var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRails2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 5.501,
    y1: 16,
    x2: 26.5,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#aa2237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#b4313d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 10.099,
    y1: 5.601,
    x2: 16.169,
    y2: 5.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#b83a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#bf4a50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 7.851,
    y1: 20.836,
    x2: 7.851,
    y2: 14.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#a92237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#972235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 13.133,
    y1: 29.442,
    x2: 13.133,
    y2: 20.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#bc4245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#a42136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 19.212,
    y1: 8.696,
    x2: 19.212,
    y2: 2.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#cc5057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#b73840"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 21.776,
    y1: 7.866,
    x2: 24.376,
    y2: 6.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#d4575f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#b63540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 22.256,
    y1: 11.733,
    x2: 26.484,
    y2: 11.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c04b51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b83a41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 22.239,
    y1: 17.79,
    x2: 26.475,
    y2: 17.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ba4044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4303c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 21.349,
    y1: 23.257,
    x2: 24.603,
    y2: 24.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f2236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 18.562,
    y1: 21.3,
    x2: 24.103,
    y2: 27.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#b22c3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#c04d53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 16.199,
    y1: 29.443,
    x2: 16.199,
    y2: 23.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#b22c3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#9b2135"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 22.221,
    y1: 6.635,
    x2: 25.29,
    y2: 6.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#f4e6d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 17.162,
    y1: 4.552,
    x2: 22.113,
    y2: 7.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#f4e6d9"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_rails") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.007,26.836A3.163,3.163,0,0,1,23.844,30H4.993V5.164A3.164,3.164,0,0,1,8.156,2H27.007Z",
    style: {
      fill: "#80152a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,26.539a2.876,2.876,0,0,1-2.945,2.945H5.5V5.461A2.876,2.876,0,0,1,8.446,2.517H26.5Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.099 2.541 10.167 8.661 5.619 10.184 10.099 2.541",
    style: {
      fill: "#8a2034"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.099 2.541 10.167 8.661 16.169 6.159 10.099 2.541",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.614 14.698 10.167 8.661 5.619 10.184 7.614 14.698",
    style: {
      fill: "#ae2338"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.614 14.698 10.133 20.836 5.568 19.365 7.614 14.698",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.108 29.442 10.133 20.836 5.568 19.365 10.108 29.442",
    style: {
      fill: "#8a2034"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.108 29.442 5.568 29.443 5.568 19.365 10.108 29.442",
    style: {
      fill: "#8c2033"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.108 29.442 10.133 20.836 16.158 23.315 10.108 29.442",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.188 2.575 22.256 8.696 16.169 6.159 22.188 2.575",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.188 2.575 22.256 8.696 26.484 10.201 22.188 2.575",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.737 14.77 22.256 8.696 26.484 10.201 24.737 14.77",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.737 14.77 22.239 20.81 26.475 19.297 24.737 14.77",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.29 29.426 22.239 20.81 26.475 19.297 22.29 29.426",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.29 29.426 22.239 20.81 16.162 23.313 22.29 29.426",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.29 29.426 10.109 29.443 16.162 23.313 22.29 29.426",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.786,16.577l1.37.628-.139-.976-1.249-.672ZM6.4,19.847l1.784.2.389-1.658-1.708-.3Zm6.345-11.48L11.575,7.5l-.812,1.1,1.281.8Zm3.576-2.9-.748-.976-1.052.621.875.952Zm3.855-.685-.241-.8-1.268-.1.368.875Zm4.287,1-1.065-.761v.494l1.027.635ZM10.065,12.868l-1.458-.634-.495,1.445,1.5.558Zm7.26-.654-.26.894.939.863.235-.831Zm5.992-4,.78.038.007-.362-.812-.165ZM20.075,5.2C16.324,5.014,9.609,8.569,8.645,22.831h9.2c-2.062-5.343-1.823-9.374-.405-12.106,2.062-3.973,5.132-4.236,8-2.561.1-.241.241-.545.241-.545A7.821,7.821,0,0,0,20.075,5.2Zm.275,2.96.342.818.634-.342-.235-.755Zm-2.08,1.858.7.958.431-.628L18.79,9.4Zm1.065,11.147L18.9,20.115l-1.592-.3.419,1.2Z",
    style: {
      fill: "#f7dee1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.969 8.329 12.069 7.869 11.575 7.503 10.969 8.329",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.392 6.059 15.684 5.87 14.654 5.256 15.392 6.059",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.862 18.089 6.449 19.649 7.427 19.964 8.18 20.05 8.569 18.392 6.862 18.089",
    style: {
      fill: "#d7c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.165,18.478Q9,19.413,8.873,20.43l1.26.406Z",
    style: {
      fill: "#d7c4c9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.449 19.649 6.397 19.847 7.427 19.964 6.449 19.649",
    style: {
      fill: "#c2c3c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.133,20.836l-1.26-.406c-.094.765-.171,1.564-.228,2.4h1.482Z",
    style: {
      fill: "#c2c3c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.127 22.831 14.981 22.831 10.133 20.836 10.127 22.831",
    style: {
      fill: "#ddc3c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.68,5.223l-.286-.2v.494l.689.426Zm.77,1.368a7.094,7.094,0,0,0-2.229-1.069l.018,1.669a6.321,6.321,0,0,1,3.05.89ZM23.317,8.214l.78.038.007-.362-.812-.165Z",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.221,5.522A9.532,9.532,0,0,0,20.075,5.2a7.357,7.357,0,0,0-3.854.985L20.04,7.773a4.373,4.373,0,0,1,2.2-.581Zm-2.05-.745-.241-.8-.087-.008-.913.543.1.237Zm.5,3.258.538.225-.119-.382Z",
    style: {
      fill: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.218,26.044v-.678A1.081,1.081,0,0,0,9.2,24.353H7.047V28.42h1.1V27.236l.888,1.184h1.319l-1.032-1.37A1.1,1.1,0,0,0,10.218,26.044Zm-1.082.2h-1v-.82h1Zm4.269-1.911h-1a1.074,1.074,0,0,0-1.023,1.057V28.4h1.082v-.794h.972V28.4h1.1V25.384A1.1,1.1,0,0,0,13.405,24.335Zm.033,2.181h-.972v-1.09h.972ZM23.5,25.8H22.442v-.444H24.3V24.351H22.436a1.08,1.08,0,0,0-1.1,1.04v.431a1.1,1.1,0,0,0,1.091,1.065h.983v.494h-2v1.027H23.38a1.082,1.082,0,0,0,1.123-.982v-.539A1.056,1.056,0,0,0,23.5,25.8Zm-4.433-1.458h-1.09v4.071H20.7V27.324h-1.63Zm-3.36,4.071H16.8V24.344H15.709Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRails2);
export default __webpack_public_path__ + "static/media/rails2.d9a4ab53af3014a5b343cc7d349bc4ae.svg";
export { ForwardRef as ReactComponent };